import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { IUniverseSelection } from './app.state';
import {
  changeActiveSideTab,
  changeActiveTab,
  submitSearch,
  navigateToResults,
  addTab,
  setActiveTab,
  setUniverseSelection,
} from './action';

@Injectable({
  providedIn: 'root'
})
export class SearchEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
  ) { }

  submitSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(submitSearch),
      switchMap(({ searchParams, searchType, sideTab: sideTabOverride }) => {

        const newTabId = uuidv4();
        let params;
        let tab_name;
        let sideTab;
        let universeSelection: IUniverseSelection;
        if (searchType === 'company') {
          params = {
            entityids: [searchParams.companies[0].entityid],
            query: null,
            entity_data: searchParams.companies[0],
            query_data: null,
            //use the extended gsubind if it exists
            gsubind: [searchParams.companies[0].gsubind_extended || searchParams.companies[0].gsubind]
          };
          tab_name = searchParams.companies[0].entity_name;
          // set the default universe selection based on the company type
           universeSelection= {
            include_public: searchParams.companies[0].companytype === 'Public Company' || searchParams.companies[0].companytype === 'Public Investment Firm',
            include_private: searchParams.companies[0].companytype === 'Private Company',
            min_mcap: undefined,
            max_mcap: undefined
          };
          sideTab='executive_summary'
          if (sideTabOverride) sideTab = sideTabOverride;
        } else if (searchType === 'theme') {
          universeSelection={
            include_public: true,
            include_private: false,
            min_mcap: undefined,
            max_mcap: undefined
          }
          params = {
            theme_search_type: searchParams.themes[0].theme_search_type,
            cluster_id: searchParams.themes[0].cluster_id ?? null,
            cluster_name: searchParams.themes[0].cluster_name ?? null,
            entityids: null,
            query: searchParams.themes[0].api_query,
            entity_data: null,
            query_data: searchParams.themes[0],
            gsubind: null
          };
          tab_name = searchParams.themes[0].category
            ? `${searchParams.themes[0].category} - ${searchParams.themes[0].name}`
            : searchParams.themes[0].name;
          sideTab = 'thematic_exec_summary';
          if (sideTabOverride) sideTab = sideTabOverride;
        } else {
          return of();
        }

        const newTab = {
          tabId: newTabId,
          search_type: searchType,
          params: params,
          sidenav_results: {},
          tab_name: tab_name,
          isLoading: false,
          universe: universeSelection
        };

        return of(
          addTab({ tab: newTab }),
          setUniverseSelection({ tabId: newTabId, selection: universeSelection }),
          changeActiveTab({ tabId: newTabId }),
          changeActiveSideTab({ sideTab: sideTab }),
          setActiveTab({ tab: newTab }),
          navigateToResults()
        );
      })
    )
  );
  navigateToResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navigateToResults),
      tap(() => {
        this.router.navigate(['/results']);
      })
    ),
    { dispatch: false }
  );


}
